
export default function ClassFeaturesSection() {
  const features = [
    {
      label: '특징1',
      category: '문학',
      description: '개념어+기이론학습, 빈도 높은 기출 해석법',
    },
    {
      label: '특징2',
      category: '독서',
      description: '지문 유형별 독서 방법, 매일 독서 과제',
    },
    {
      label: '특징3',
      category: '문법',
      description: '핵심 개념 및 체화를 통한 기출 실전 감각',
    },
    {
      label: '특징4',
      category: '주간Test',
      description: '당일 수업 이해도 점검 후 학습방 전송',
    },
    {
      label: '특징5',
      category: '월간 모고',
      description: '3,6,9,11월 전국학평대비 모의 훈련',
    },
    {
      label: '특징6',
      category: '수행평가',
      description: '학교별 수행 필요 자료 제공 및 첨삭',
    },
    {
      label: '특징7',
      category: '관리',
      description: '학생&학부모&강사 학습방 운영',
    },
  ];

  const labelColors = [
    'text-[#ff6b6b]',
    'text-[#4ecdc4]',
    'text-[#ffd93d]',
    'text-[#ff6b6b]',
    'text-[#4ecdc4]',
    'text-[#ffd93d]',
    'text-[#ff6b6b]',
  ];

  const dotColors = [
    'bg-[#ff6b6b]',
    'bg-[#4ecdc4]',
    'bg-[#ffd93d]',
    'bg-[#ff6b6b]',
    'bg-[#4ecdc4]',
    'bg-[#ffd93d]',
    'bg-[#ff6b6b]',
  ];

  return (
    <section id="class-features" className="py-14 md:py-24 bg-[#f7f7f5]">
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <p className="text-[13px] md:text-base text-[#ff6b6b] font-medium mb-4 tracking-wider">
            Class Features
          </p>
          <h2
            className="text-[1.6rem] md:text-5xl font-bold text-[#1a2332] mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            후니국담 <span className="text-[#4ecdc4]">수업 특징</span>
          </h2>
          <p className="text-gray-500 text-[14px] md:text-lg leading-relaxed">
            체계적인 수업 시스템으로 국어 실력을 완성합니다
          </p>
        </div>

        {/* Content Area */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          {/* Left Side - Visual Card */}
          <div className="lg:col-span-4">
            <div className="bg-gradient-to-br from-[#1a2332] to-[#2a3f5f] rounded-2xl p-8 md:p-10 h-full flex flex-col items-center justify-center text-center min-h-[320px]">
              <p className="text-gray-300 text-base font-medium mb-3 tracking-wider">
                열린학원
              </p>
              <h3
                className="text-5xl md:text-6xl font-black text-[#ffd93d] leading-tight mb-4"
                style={{ fontFamily: 'Noto Serif KR, serif' }}
              >
                국담에<br />대하여
              </h3>
              <div className="w-16 h-1 bg-[#4ecdc4] rounded-full mb-4"></div>
              <p className="text-gray-400 text-sm">
                7가지 수업 특징
              </p>
            </div>
          </div>

          {/* Right Side - Table */}
          <div className="lg:col-span-8">
            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              {/* Table Header */}
              <div className="bg-gradient-to-br from-[#1a2332] to-[#2a3f5f] px-8 py-6 text-center">
                <h3
                  className="text-2xl md:text-3xl font-bold text-[#ffd93d]"
                  style={{ fontFamily: 'Noto Serif KR, serif' }}
                >
                  국담 수업 특징
                </h3>
              </div>

              {/* Desktop Table */}
              <div className="hidden md:block">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-[#f7f7f5]">
                      <th className="py-3.5 px-5 text-[#1a2332] text-sm font-bold text-center w-[90px] border-b border-gray-200">구분</th>
                      <th className="py-3.5 px-5 text-[#1a2332] text-sm font-bold text-center w-[120px] border-b border-gray-200">영역</th>
                      <th className="py-3.5 px-5 text-[#1a2332] text-sm font-bold text-left border-b border-gray-200">내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    {features.map((item, index) => {
                      const isLast = index === features.length - 1;
                      return (
                        <tr
                          key={item.label}
                          className={`${!isLast ? 'border-b border-gray-100' : ''} hover:bg-gray-50/50 transition-colors duration-200`}
                        >
                          <td className="py-4.5 px-5 text-center border-r border-gray-100">
                            <span className={`text-sm font-bold ${labelColors[index]}`}>
                              {item.label}
                            </span>
                          </td>
                          <td className="py-4.5 px-5 text-center border-r border-gray-100">
                            <span className="text-[#1a2332] text-base font-semibold">
                              {item.category}
                            </span>
                          </td>
                          <td className="py-4.5 px-5">
                            <div className="flex items-center gap-2.5 text-gray-700 text-base leading-relaxed">
                              <span className={`w-2 h-2 rounded-full ${dotColors[index]} flex-shrink-0`}></span>
                              {item.description}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile Cards */}
              <div className="md:hidden p-4 space-y-3">
                {features.map((item, index) => (
                  <div key={item.label} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                    <div className="flex items-center gap-3 mb-2">
                      <span className={`text-[13px] font-bold ${labelColors[index]}`}>
                        {item.label}
                      </span>
                      <span className="text-[#1a2332] text-[15px] font-semibold">
                        {item.category}
                      </span>
                    </div>
                    <div className="flex items-start gap-2 text-gray-700 text-[14px] leading-[1.7] pl-1">
                      <span className={`mt-1.5 w-1.5 h-1.5 rounded-full ${dotColors[index]} flex-shrink-0`}></span>
                      {item.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
